<template>
  <!--  <div id="app_box" class="scale-wrapper">-->
  <!--  <el-button @click="changeTheme">切换主题颜色</el-button>-->
  <!--  v-if="!isMobileFlag"-->
  <router-view v-slot="{ Component, route }" v-loading>
    <keep-alive :include="[...visitedViewPathsResult]">
      <component
          :is="Component"/>
    </keep-alive>
  </router-view>
  <!--  <Device v-else @change="changeStatus"></Device>-->
  <!--  </div>-->
</template>
<script setup>
import {onMounted, computed, watch, ref, onBeforeUnmount} from "vue";
import {useStore} from "vuex";
import {loadLanguageAsync} from "@/lang";
import {useRoute, useRouter} from "vue-router";
import {useWebSocket} from "@/Hooks";
import {isMobile} from "@/utils/device";
import Device from "@/views/Device/index.vue"
import {chat} from "./store/modules/chat";
import TencentCloudChat from "@tencentcloud/chat";
import {showNotify} from "@/utils/notifies";

const store = useStore();
const router = useRouter();
const route = useRoute();

const isMobileFlag = ref(false);
const userInfo = computed(() => store.state.user.userInfo);
const langLocal = computed(() => store.state.system.langLocal)
// teamId 初始化为 0 问题
const teamId = computed(() => store.state.email.teamID);
const isEnterpriseMainUser = computed(() => store.getters['user/isEnterpriseMainUser']);
// 用户接受继续访问
const changeStatus = () => {
  isMobileFlag.value = false
}

watch(() => langLocal.value, (lang) => {
  loadLanguageAsync(lang)
  // routerToI18n() //多语言绑定
}, {immediate: true})

// 发送消息
const userId = JSON.parse(localStorage.getItem("userInfo"))?.id || ''

// onMounted(async () => {
//   isMobileFlag.value = isMobile();
//   // 获取默认主题
//   // let html = document.querySelector('html')
//   // html.setAttribute('data-theme', localStorage.getItem("theme"));
//   // 弹窗测试
//   // let target = {
//   //   "msg_front_from": "<CMCCAccountaasdfasdasdfasfdo@139.com>",
//   //   "msgTxt": "回复：RE：hello world@阿里山来的拉迪说ASDf阿斯顿发堷企鹅们阿里山地方asdfasdfasdasd",
//   //   "msg_front_subject":"回复：RE：hello world@阿里山来的拉迪说ASDf阿斯顿发堷企鹅们阿里山地方asdfasdfasdasd",
//   //   "msg_front_type": "msg_front_email",
//   //   "userId": "1764907866498379777"
//   // }
//   //
//   // target.msgTxt = truncateByBytes(target.msgTxt,60)
//   // console.log(target,'tar')
//   // showNotify(1, target)
//
//   // startLoading()
//   if (userInfo.value.companyId) {
//     localStorage.setItem('companyId', userInfo.value.companyId);
//   }
//   if (teamId.value) {
//     await store.dispatch("user/checkUserInfoIsAdmin", {teamId: teamId.value, isUpdate: true})
//   }
//   await store.dispatch('chat/initChat', userInfo.value.id);
//   // userTime()
// })

onMounted(() => {
  isMobileFlag.value = isMobile();
  // 初始化执行一次
  handleRouteChange(route.path);
});

watch(
    () => route.path,
    (newPath) => {
      handleRouteChange(newPath);
    }
);

function handleRouteChange(path) {
  console.log(path, '当前路径');
  if (path.startsWith("/cloud/download") || path.startsWith("/cloud/info")) {
    console.log("文件分享路径");
    return;
  }

  isMobileFlag.value = isMobile();

  if (userInfo.value.companyId) {
    localStorage.setItem("companyId", userInfo.value.companyId);
  }

  if (teamId.value) {
    store.dispatch("user/checkUserInfoIsAdmin", {
      teamId: teamId.value,
      isUpdate: true,
    });
  }

  // store.dispatch("chat/initChat", userInfo.value.id);
}

const currConversation = computed(() => store.state.chat.currConversation)
// 监听处理
chat.on(TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED, (conversationList) => {
  store.dispatch('chat/updateConversationList');

  for (const conversation of conversationList.data) {
    if (conversation.conversationID === currConversation.value.conversation.conversationID) {
      store.dispatch('chat/updateCurrentConversation', {conversation});
      break;
    }
  }
});
chat.on(TencentCloudChat.EVENT.GROUP_LIST_UPDATED, () => store.dispatch('chat/updateGroupList'));

// 收到消息后更新右下角弹窗信息
chat.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, async (e) => {
  const conversationID = e.data[0].conversationID;
  const result = await chat.getConversationProfile(conversationID);
  store.dispatch('chat/updateCurrentConversation', {conversation: result.data.conversation});
});

// onBeforeUnmount(() => {
//   timerUser.value = null;
// })

// 主题切换
// const changeTheme = () => {
//   console.log('切换主题颜色')
//   let html = document.querySelector('html')
//   let currentTheme = html.getAttribute('data-theme');
//   console.log(currentTheme, 'currentTheme')
//   if (currentTheme === "light" || currentTheme === null) {
//     html.setAttribute('data-theme', 'dark');
//     localStorage.setItem("theme", "dark")
//   } else {
//     html.setAttribute('data-theme', 'light');
//     localStorage.setItem("theme", "light")
//   }
// }

let timers = null;
const emailMessages = ref([])
const emailData = computed(() => store.state.message.emailData)
// websocket 请求
const {startWS, stopWS} = useWebSocket(userId, store);
onMounted(async () => {
  if (userId) {
    await startWS();
  } else {
    await stopWS()
  }

  console.log(router.options.routes, 'router')
})

function getAllNames(data, result = []) {
  if (Array.isArray(data)) {
    data.forEach(item => {
      if (item.name) {
        result.push(item.name);
      }
      if (item.children) {
        getAllNames(item.children, result);
      }
    });
  }
  return result;
}

// 路由缓存
const visitedViewPathsResult = getAllNames(router.options.routes);

// 权限 轮训 实时反馈
// const timerUser = ref(null)
// const userTime = () => {
//   timerUser.value = setInterval(async () => {
//     console.log('timer')
//     await store.dispatch("user/checkUserInfoIsAdmin", {teamId: teamId.value, isUpdate: true})
//   }, 5000)
// }


// 监听storage事件，及时同步用户信息
window.addEventListener('storage', (e) => {
  if (e.key === "token" && (e.newValue === null || e.newValue !== e.oldValue)) {
    location.reload();
  }
});

// main.js 或 App.vue setup
//
// window.addEventListener('storage', (e) => {
//   if (e.key === 'tabIndex') {
//     const newIndex = e.newValue === null ? null : Number(e.newValue)
//     // 更新你的全局状态或局部 ref
//     // store.commit("system/setTabIndex", newIndex);
//     localStorage.setItem("tabIndex", newIndex)
//     location.reload();
//   }
// })


// function updateScale() {
//   const screenWidth = window.innerWidth;
//   const screenHeight = window.innerHeight;
//
//   // 获取当前容器的原始尺寸（假设是 1920x1080 可替换成其他值）
//   const baseWidth = 1920;
//   const baseHeight = 1080;
//
//   const scaleX = screenWidth / baseWidth;
//   const scaleY = screenHeight / baseHeight;
//
//   const app = document.getElementById('app');
//   if (app) {
//     app.style.transformOrigin = 'top left';
//     app.style.transform = `scale(${scaleX})`;
//   }
// }
//
// onMounted(() => {
//   updateScale();
//   window.addEventListener('resize', updateScale);
// });
//
// onBeforeUnmount(() => {
//   window.removeEventListener('resize', updateScale);
// });

</script>
<style lang="less" scoped>
body {
  width: 100% !important;
}

:deep(.el-table) {
  font-weight: normal !important;
}

:deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner) {
  background-color: var(--el-checkbox-checked-bg-color) !important;
  border-color: var(--el-checkbox-checked-input-border-color) !important;
}

:deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner:after) {
  border-color: var(--el-checkbox-checked-icon-color) !important;
}

.scale-wrapper {
  width: 1920px;
  height: 1080px;
  transform-origin: top left;
  position: absolute;
  left: 0;
  top: 0;
}

:deep(.el-input-group__append) {
  box-shadow: none !important;
}
</style>
